import { SpaceHierarchyReadModel } from '@client/api';

/**
 * Recursively flatten a SpaceHierarchyReadModel tree into a map of spaceId → ancestor path string.
 * The ancestor path excludes the node itself (since its name is shown in the "Navn" column).
 */
export function buildAncestorPathMap(
  node: SpaceHierarchyReadModel,
  parentPath: string[] = [],
): Map<string, string> {
  const map = new Map<string, string>();
  const currentAncestorPath = parentPath.length > 0 ? parentPath.join(' › ') : '';
  map.set(node.id, currentAncestorPath);

  const childParentPath = [...parentPath, node.name];
  for (const child of node.children ?? []) {
    const childMap = buildAncestorPathMap(child, childParentPath);
    childMap.forEach((value, key) => map.set(key, value));
  }

  return map;
}
